import React, { useMemo, forwardRef } from 'react';
import Type from 'prop-types';
import { Tab } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const TabLink = props => {
  const { value } = props;

  const renderLink = useMemo(
    () => forwardRef((itemProps, ref) => <RouterLink to={value} {...itemProps} innerRef={ref} />),
    [value],
  );

  return <Tab component={renderLink} {...props} />;
};

TabLink.propTypes = {
  value: Type.string.isRequired,
};

export default TabLink;
